/**
 * Created by zzy on 2019/8/1.
 */
import MonitoringDevice from './MonitoringDevice.vue'
export default MonitoringDevice



// WEBPACK FOOTER //
// ./src/views/assets/monitoringDevice/index.js